export default "__VITE_ASSET__NIahspxO__";